import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import SiteHeader from '@/components/generals/site-header'
import SiteFooter from '@/components/generals/site-footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='relative flex min-h-screen flex-col'>
            <SiteHeader />
            <main id='main' className='flex-1'>
                {children}
            </main>
            <SiteFooter />
            <div className='paper-texture' aria-hidden='true' />
        </div>
    )
}
